import { useState } from "react"
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"
import "./PasswordReset.css"
import config from "./config.json"
import Bot from "./bot"

const EmailSentPage = () => {
  const [responseMessage, setResponseMessage] = useState("")
  const [isSending, setIsSending] = useState(false)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const email = searchParams.get("email") || ""  // Extract email from URL params

  const handleBotLoad = (hubspot) => {
    // Bot loaded callback
  }

  const handleResendVerification = async () => {
    if (!email) {
      setResponseMessage("Email address is missing. Please try signing up again.")
      return
    }

    setIsSending(true)
    try {
      const response = await fetch(`${config.AUTH_BASE_URL}/api/user/send-mail/verify-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
        }),
      })

      const data = await response.json()

      if (data.status === 200) {
        setResponseMessage("Verification email has been resent. Please check your inbox.")
      } else {
        setResponseMessage("Failed to resend verification email. Please try again later.")
      }
    } catch (error) {
      console.error("Error:", error)
      setResponseMessage("Failed to resend verification email. Please try again later.")
    } finally {
      setIsSending(false)
    }
  }

  const handleLogo = () => {
    navigate("/")
  }

  return (
    <div className="password-reset-container">
      <header className="password-reset-header">
        <img src="/logo.svg" alt="Logo" className="logo" onClick={handleLogo} />
      </header>

      <div className="password-reset-form">
        <h2>
          Email <span style={{ color: "#672024" }}>Verification</span>
        </h2>

        <div style={{ textAlign: "center", maxWidth: "500px", margin: "0 auto" }}>
          <p>
            A verification email has been sent to <strong>{email}</strong>.
          </p>
          <p>Please check your inbox and click on the verification link to activate your account.</p>

          {responseMessage && (
            <p className="response-message" style={{ color: responseMessage.includes("resent") ? "green" : "red" }}>
              {responseMessage}
            </p>
          )}

          <button
            className="submit-button"
            onClick={handleResendVerification}
            disabled={isSending}
            style={{ marginTop: "20px" }}
          >
            {isSending ? "Sending..." : "Resend Verification Email"}
          </button>

          <p style={{ marginTop: "20px" }}>
            <a href="/login" style={{ color: "#5b161a", textDecoration: "none" }}>
              Return to Login
            </a>
          </p>
        </div>
      </div>

      <footer className="footer">
        <p>MayaMaya Suite of Products - MayaMaya Lite</p>
      </footer>
      <Bot onLoad={handleBotLoad} />
    </div>
  )
}

export default EmailSentPage

